import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement } from '../../../base/outline-element/outline-element';
import { customElement } from 'lit/decorators.js';
import componentStyles from './ghs-footer-slotted-utility-menu.css.lit';
import { SlotController } from '../../../controllers/slot-controller';

/**
 * The GhsFooterSlottedUtilityMenu component
 * @element ghs-footer-slotted-utility-menu
 * @slot - default slot
 */
@customElement('ghs-footer-slotted-utility-menu')
export class GhsFooterSlottedUtilityMenu extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];
  slots = new SlotController(this, true);

  render(): TemplateResult {
    return html`<slot></slot>`;
  }
}
